export default __webpack_public_path__ + "static/media/adp-horizontal-01.6f2402e9.svg";